import {
  RedoModal,
  RedoModalButtonProps,
} from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { memo, useState } from "react";

export const ConfirmDeleteSupportV2FolderModal = memo(
  function ConfirmDeleteSupportV2FolderModal({
    isOpen,
    onClose,
    onSubmit,
    folderName,
  }: {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => Promise<void>;
    folderName: string;
  }) {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
      try {
        setIsSubmitting(true);
        await onSubmit();
        onClose();
      } finally {
        setIsSubmitting(false);
      }
    };

    const primaryButton: RedoModalButtonProps = {
      text: "Delete",
      onClick: handleSubmit,
      disabled: isSubmitting,
      theme: "destructive",
      size: "sm",
    };

    const secondaryButton: RedoModalButtonProps = {
      text: "Cancel",
      onClick: onClose,
      disabled: isSubmitting,
      pending: false,
      size: "sm",
    };

    return (
      <RedoModal
        isOpen={isOpen}
        modalSize="sm"
        onModalCloseRequested={isSubmitting ? () => {} : onClose}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
        subtitle={`Are you sure you want to delete the folder "${folderName}"? Views in this folder will not be deleted.`}
        title="Delete folder"
      />
    );
  },
);
